export default __webpack_public_path__ + "static/media/pan-south.f3e9322e.png";